export const getDecliningAllPlans = (enrollmentObject, dentalPlan, visionPlan) =>
  [enrollmentObject.is_enrolling, dentalPlan && enrollmentObject.is_enrolling_dental, visionPlan && enrollmentObject.is_enrolling_vision].indexOf(true) === -1;

export const getDependentsDecliningAllPlans = (employee, dentalPlan, visionPlan) =>
  employee.dependents.map((dependent) => getDecliningAllPlans(dependent, dentalPlan, visionPlan)).indexOf(false) === -1;

export const employeeCopyWithFullCoverage = (employee) => {
  const enrollmentObject = {
    is_enrolling: true,
    is_enrolling_dental: true,
    is_enrolling_vision: true,
  };

  const employeeCopy = {
    ...employee,
    ...enrollmentObject,
  };

  if (employee.spouse_enrollment) {
    employeeCopy.spouse_enrollment = enrollmentObject;
  }
  if (employee.children_enrollment) {
    employeeCopy.children_enrollment = employee.children_enrollment.map((_) => enrollmentObject);
  }
  employeeCopy.dependents = employeeCopy.dependents.map((dependent) => ({
    new: "string",
    ...dependent,
    ...enrollmentObject,
  }));

  return employeeCopy;
};

export const getPricingSegmentMedical = (employee) => {
  const { dependents } = employee;
  if (dependents.every((dependent) => !dependent.is_enrolling)) {
    return "employeeOnly";
  }

  const spouse = dependents.find((dependent) => dependent.name === "Spouse");
  const children = dependents.filter((dependent) => dependent.name.includes("Child") && dependent.is_enrolling);

  if (spouse && spouse.is_enrolling && children.length === 0) {
    return "employeeAndSpouse";
  }
  if ((!spouse || !spouse.is_enrolling) && children.length) {
    return "employeeAndChildren";
  }
  if (spouse && spouse.is_enrolling && children.length) {
    return "employeeAndFamily";
  }
};

export const getPricingSegmentAncillary = (employee, planType) => {
  const { dependents } = employee;
  if (dependents.every((dependent) => !dependent[`is_enrolling_${planType}`])) {
    return "employeeOnly";
  }

  const spouse = dependents.find((dependent) => dependent.name === "Spouse");
  const children = dependents.filter((dependent) => dependent.name.includes("Child") && dependent[`is_enrolling_${planType}`]);

  if (spouse && spouse[`is_enrolling_${planType}`] && children.length === 0) {
    return "employeeAndSpouse";
  }
  if ((!spouse || !spouse[`is_enrolling_${planType}`]) && children.length) {
    return "employeeAndChildren";
  }
  if (spouse && spouse[`is_enrolling_${planType}`] && children.length) {
    return "employeeAndFamily";
  }
};
